import { form } from '../formState'

export function useFieldsVisibility(creating: boolean) {
  const limitedAccess = form.useFormField('limitedAccess')
  const type = form.useFormField('type')
  const typeValue = type.field.value

  const limitedAccessFieldVisible =
    typeValue === 'viewer' || typeValue === 'planner' || typeValue === 'guest'

  const canShow = {
    password: creating,
    limitedAccess: limitedAccessFieldVisible,
    territoryFilter: limitedAccess.field.value && limitedAccessFieldVisible,
    courier: typeValue === 'courier',
    companies: typeValue === 'guest',
  }

  return { canShow }
}
